import { motion } from "framer-motion";
import { ShieldAlert, Eye, Zap, BadgeCheck } from "lucide-react";

const PRINCIPLES = [
  { n: "01", icon: ShieldAlert, label: "DISIPLIN" },
  { n: "02", icon: Eye, label: "KESEDARAN SITUASI" },
  { n: "03", icon: Zap, label: "KESIAPSIAGAAN" },
  { n: "04", icon: BadgeCheck, label: "PROFESIONALISME" },
];

export function CoursePurpose() {
  return (
    <section data-testid="kursus-purpose" className="relative bg-kursus-bg2 py-20 sm:py-28 overflow-hidden">
      <div className="kursus-tactical-grid" />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="font-anton uppercase text-3xl sm:text-5xl text-kursus-white leading-tight mb-6"
        >
          BUKAN SEKADAR<br /><span className="text-kursus-gold">BERDIRI DI SISI.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.15 }}
          className="text-kursus-muted text-sm sm:text-base max-w-2xl mx-auto mb-14 leading-relaxed"
        >
          Tugas pengawal peribadi memerlukan disiplin, kewaspadaan, komunikasi, kesiapsiagaan dan
          kefahaman terhadap tanggungjawab perlindungan.
        </motion.p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {PRINCIPLES.map((p, i) => (
            <motion.div
              key={p.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              data-testid={`kursus-principle-${p.n}`}
              className="flex flex-col items-center"
            >
              <p className="font-anton text-4xl sm:text-5xl text-kursus-gold/25 mb-2">{p.n}</p>
              <p.icon className="w-6 h-6 text-kursus-gold mb-3" />
              <p className="font-oswald text-xs sm:text-sm tracking-[0.15em] text-kursus-white">{p.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
